import axios from "axios";
import React, { useState, useEffect } from "react";
import { pageTitle } from "../../helpers/PageTitle";
import "../../sass/shortcode/Signinup.scss";
import "../../sass/shortcode/SigninBanner.scss";
import { BASE_URL } from "../../helpers/api";
import { Link } from "react-router-dom";

import {
  FaEye,
  FaEyeSlash,
  FaUserCircle,
  FaEnvelope,
  FaLock,
  FaArrowRight,
} from "react-icons/fa";

export default function SignIn() {
  pageTitle("Sign In");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Load saved email on first render
  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Handle Remember Me
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }

    try {
      const res = await axios.post(
        `${BASE_URL}/auth/login`,
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Login successful");

      const { user, token, role } = res.data;
      const patientId = res.data.user.patient_id;

      const storage = rememberMe ? localStorage : sessionStorage;

      storage.setItem("userId", user.id);
      storage.setItem("userRole", user.role ?? "patient");
      storage.setItem("userEmail", user.email);
      storage.setItem("userName", [user.firstname, user.lastname].filter(Boolean).join(" ").trim());
      storage.setItem("userPhone", user.mobile);
      storage.setItem("token", token);
      storage.setItem("patientId", res.data.user.patient_id);

      // Redirect based on role
      // if (role === "admin") {
      //   window.location.href = "/admin/dashboard";
      // } else if (role === "doctor") {
      //   window.location.href = "/doctor/dashboard";
      // } else {
      //   window.location.href = "/patientprofile";
      // }

      // Redirect based on role
      if (role === "admin") {
        window.location.href = "/admin/dashboard";
      } else if (role === "doctor") {
        window.location.href = "/doctor/dashboard";
      } else {
        // Check if user came from booking flow
        const redirect = localStorage.getItem("redirectAfterLogin");
        if (redirect) {
          localStorage.removeItem("redirectAfterLogin");
          window.location.href = redirect;
        } else {
          window.location.href = "/patientprofile";
        }
      }
    } catch (err) {
      console.error(err);
      alert("Please check your email and password");
    }
  };

  return (
    <>
      <section className="cs_signin_banner">
        <span className="cs_signin_dots" />
        <div className="container">
          <div className="cs_signin_banner_row">
            <div className="cs_signin_banner_left">
              <h1>Welcome Back!</h1>
              <span className="cs_signin_underline" />
              <p>
                Login to access your personalized dashboard, manage your
                appointments, and stay connected with your healthcare journey
              </p>
              <a href="#signin-form" className="cs_signin_cta">
                <FaUserCircle /> Sign In to Your Account
              </a>
            </div>
            <div className="cs_signin_banner_right">
              <img
                src="/images/signin_banner_illustration.png"
                alt="Sign in"
              />
            </div>
          </div>
        </div>
      </section>

      <div className="signin-container" id="signin-form">
        <div className="signin-wrapper">
          {/* LEFT IMAGE */}
          <div className="signin-left">
            <img
              src="/images/auth-img.png"
              alt="Login Illustration"
              className="signin-image"
            />
          </div>

          {/* RIGHT FORM */}
          <div className="signin-form">
            <span className="signin-form-icon">
              <FaUserCircle />
            </span>
            <h2 className="signin-title">Sign In to your Account</h2>
            <p className="signin-subtitle">Welcome back! Please enter your details</p>

            <form onSubmit={handleSubmit}>
              {/* EMAIL */}
              <div className="form-group">
                <label>Email</label>
                <div className="form-input-wrap">
                  <span className="form-input-icon">
                    <FaEnvelope />
                  </span>
                  <input
                    type="email"
                    className="form-input"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    required
                  />
                </div>
              </div>

              {/* PASSWORD WITH EYE ICON */}
              <div className="form-group">
                <label>Password</label>
                <div className="form-input-wrap">
                  <span className="form-input-icon">
                    <FaLock />
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-input"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              {/* REMEMBER ME + FORGOT PASSWORD */}
              <div className="form-options">
                <label className="remember-me" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  Remember me
                </label>

                <Link to="/forgot-password" className="forgot-password">
                  Forgot Password?
                </Link>
              </div>

              {/* SUBMIT BUTTON */}
              <button type="submit" className="submit-button">
                Sign In <FaArrowRight />
              </button>

              <div className="divider">
                <hr />
                <span>OR</span>
                <hr />
              </div>

              {/* SIGN UP LINK */}
              <p className="signup-link">
                Don’t have an account? <Link to="/signup">Sign Up</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}